import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useContext } from './Context';
import Plans from './Plans/Index';
import ChoosePolicyTemplate from './Plans/New/ChoosePolicyTemplate';

export default function Home({ policyEnabled }) {
  const { dispatch: dispatchPlans, actions: actionsPlans, state: statePlans } = useContext();

  useEffect(() => {
    actionsPlans.load(dispatchPlans);
  }, []);

  return (
    statePlans.plans.length > 0 ? <Plans />
      : (
        <ChoosePolicyTemplate
          policyEnabled={policyEnabled}
          showCurrency={statePlans.currencyId === ''}
        />
      )
  );
}

Home.propTypes = {
  policyEnabled: PropTypes.bool,
};

Home.defaultProps = {
  policyEnabled: true,
};
